/**
 * YouTube IFrame Player onError codes.
 * https://developers.google.com/youtube/iframe_api_reference#onError
 *
 * Runtime classification only. Transient errors must not be persisted as
 * provider truth. 101/150 may later be recorded as embed_blocked on refresh.
 */
export const YOUTUBE_IFRAME_ERROR_CODES = Object.freeze({
  INVALID_PARAMETER: 2,
  HTML5_PLAYER: 5,
  NOT_FOUND: 100,
  NOT_EMBEDDABLE: 101,
  EMBED_BLOCKED: 150,
  PLAYER_CONFIG: 153,
});

export const YOUTUBE_IFRAME_ERROR_CLASSES = Object.freeze({
  INVALID_PARAMETER: 'invalid_parameter',
  HTML5_PLAYER: 'html5_player',
  UNAVAILABLE: 'unavailable',
  EMBED_BLOCKED: 'embed_blocked',
  PLAYER_CONFIG: 'player_config',
  UNKNOWN: 'unknown',
});

const HOST_SKIP_MESSAGE = 'That source became unavailable — finding another.';

export function classifyYoutubeIframeError(code) {
  const numeric = Number(code);
  switch (numeric) {
    case YOUTUBE_IFRAME_ERROR_CODES.NOT_EMBEDDABLE:
    case YOUTUBE_IFRAME_ERROR_CODES.EMBED_BLOCKED:
      return {
        code: numeric,
        class: YOUTUBE_IFRAME_ERROR_CLASSES.EMBED_BLOCKED,
        persistable: false,
        hostMessage: HOST_SKIP_MESSAGE,
        reportable: true,
      };
    case YOUTUBE_IFRAME_ERROR_CODES.NOT_FOUND:
      return {
        code: numeric,
        class: YOUTUBE_IFRAME_ERROR_CLASSES.UNAVAILABLE,
        persistable: false,
        hostMessage: HOST_SKIP_MESSAGE,
        reportable: true,
      };
    case YOUTUBE_IFRAME_ERROR_CODES.PLAYER_CONFIG:
      return {
        code: numeric,
        class: YOUTUBE_IFRAME_ERROR_CLASSES.PLAYER_CONFIG,
        persistable: false,
        hostMessage: HOST_SKIP_MESSAGE,
        reportable: true,
      };
    case YOUTUBE_IFRAME_ERROR_CODES.INVALID_PARAMETER:
      return {
        code: numeric,
        class: YOUTUBE_IFRAME_ERROR_CLASSES.INVALID_PARAMETER,
        persistable: false,
        hostMessage: HOST_SKIP_MESSAGE,
        reportable: true,
      };
    case YOUTUBE_IFRAME_ERROR_CODES.HTML5_PLAYER:
      return {
        code: numeric,
        class: YOUTUBE_IFRAME_ERROR_CLASSES.HTML5_PLAYER,
        persistable: false,
        hostMessage: HOST_SKIP_MESSAGE,
        reportable: false,
      };
    default:
      return {
        code: Number.isFinite(numeric) ? numeric : null,
        class: YOUTUBE_IFRAME_ERROR_CLASSES.UNKNOWN,
        persistable: false,
        hostMessage: HOST_SKIP_MESSAGE,
        reportable: false,
      };
  }
}
